import { http } from '../utils/http';

export function getAlerts(signal) {
    return http.get('/alerts-status', { signal });
}

export function getCriticalAlerts(signal) {
    return http.get('/critical-alerts', { signal });
}
